// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"317":"36203d70","626":"b534aca9"}[chunkId] + ".chunk.css";
};